import router from "../router";
import NProgress from "nprogress";
import "nprogress/nprogress.css";
import cookie from "@/api/cookie";
import store from "@/store";

NProgress.configure({showSpinner: false});

router.beforeEach(async (to, from, next) => {
	
	
	NProgress.start();
	
	if(!to.meta.front){
		document.title = process.env.VUE_APP_TITLE;
		document.querySelector('link[rel="icon"]').href= `${process.env.BASE_URL}favicon/${process.env.VUE_APP_FAVICON}.ico`;
	}
	
	if (to.meta.noAuth) {
		next();
		return;
	}
	
	const hasToken = cookie.getToken();
	
	if (!hasToken) {
		next({path: '/login', replace: true});
		return
	}
	
	
	if (hasToken) {
		if (!store.state.user.userInfo) {
			await store.dispatch("user/getUserInfo");
		}
		next();
		return;
	}
	
	next();
	
});

router.afterEach(() => {
	NProgress.done();
});
